<template>
    <div class="pieChart"></div>
</template>

<script>
export default {
    name: '',
    props: {
        pondsid:Number,
        
    },
    data() {
        return {
            myChart: null,
            xData:[],
            yData:[]
        }
    },
    methods: {
        setData() {
            this.request.get("/api/Echart/getpage2", {
                params: {
                    pondsid: this.pondsid,
                    param: "Tem",
                    number: 10
                }
            }).then(res => {
                if (res.code == 200) {
                    let data = res.data;
                    this.xData = data.map(item => {
                        const timeParts = item.time.split(' ');
                        const datePart = timeParts[0];
                        const timePart = timeParts[1];
                        const month = datePart.substring(5, 7);
                        const day = datePart.substring(8, 10);
                        const hour = timePart.substring(0, 2);
                        const minute = timePart.substring(3, 5);
                        return `${month}-${day} ${hour}:${minute}`;
                    });
                    this.yData = data.map(item => item.tem);
                    this.updateDynamicYAxis(); // 计算并更新y轴最小值
                }
                this.setChart();
            });
        },
        updateDynamicYAxis() {
            if (this.yData.length > 0) {
                const minVal = Math.min(...this.yData);
                this.yAxisMin = Math.floor((minVal - 0.3) * 10) / 10; // 减去0.5以确保所有数据都能清晰显示
            }
        },
        setChart() {
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    backgroundColor: '#11367a',
                    textStyle: {
                        color: '#6dd0e3',
                        fontSize: 10,
                    },
                },
                grid: {
                    top: '12%',
                    bottom: '12%',
                    left: '8%',
                    right: '5%',
                },
                legend: {
                    right: '5%',
                    top: '10%',
                    itemWidth: 7,
                    itemHeight: 7,
                    textStyle: {
                        color: '#fff',
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10,
                    },
                    axisLine: {
                        symbol: ['none', 'arrow'],
                        symbolSize: [6, 6],
                        symbolOffset: [0, 5],
                        lineStyle: {
                            color: '#122C49'
                        }
                    },
                    axisTick: {
                        color: '#122C49',
                        inside: true
                    },
                    z: 2,
                    data: this.xData
                },
                yAxis:
                    {
                        type: 'value',
                        
                        min: this.yAxisMin, // 使用动态最小值

                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            lineStyle: {
                                color: '#122C49'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            showMaxLabel: false,
                            fontSize: 10
                        },
                        splitLine: {
                            show: false,
                        },
                        name: '(℃)',
                        nameGap: -10,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 9,
                            align: 'right',
                            padding: [0, 6, 0, 0]
                        },
                    },

                series: [{
                    name: '温度',
                    type: 'line',
                    symbol: 'none',
                    data: this.yData,
                    lineStyle: {
                        width: 1,
                        color:{
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#F0F8FF' // 0% 处的颜色
                            },
                                {
                                    offset: 0.5, color: '#AFEEEE' // 40% 处的颜色
                                }, {
                                    offset: 1, color: '#87CEFA' // 100% 处的颜色
                                }],
                            global: false // 缺省为 false
                        } //背景渐变色
                    },
                    itemStyle: {
                        color: '#8552a1'
                    },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#43CBFF' // 0% 处的颜色
                            },
                            {
                                    offset: 1, color: '#9708CC' // 100% 处的颜色
                                }],
                            global: false // 缺省为 false
                        }, //背景渐变色
                        origin: 'start'
                    }
                },
                ]
            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize()
            this.myChart.setOption(option);
        }
    },
    mounted() {
        this.setData()
    },
    watch: {
        pondsid() {
            this.setData()

        }
    }
}
</script>

<style lang="less" scoped>
.pieChart {
    height: 100%;
    width: 100%;
    padding: 0 20px;
}
</style>
